import { getAccessToken, axios } from 'utils/common';
import { sessionConfig } from 'utils/constant';

export const micService = {
  getRfidListWithFilters(params) {
    const { projid, data = {} } = params;
    const URL = `Rfids/${projid}/List`;

    return axios({
      method: 'post',
      url: URL,
      data,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },

  modifyRfidStepDetails(params) {
    const { StepCode, Data } = params;
    const URL = `Rfids/Modification`;

    return axios({
      method: 'put',
      url: URL,
      data: {
        StepCode,
        Data
      },
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },

  modifyMultiRfidStepDetails(params) {
    const URL = `Rfids/Modification/Multi`;

    return axios({
      method: 'put',
      url: URL,
      data: params,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },

  getRfidDetail(params) {
    const URL = `Rfids/${params.id}/Detail`;

    return axios({
      method: 'get',
      url: URL,
      params: {
        projid: params.projid
      },
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },

  getBcTypes(params) {
    // const UserProjSection = getUserProjSection();

    const URL = `Masters/${params.projid}/Bcs/Types/FullList`;

    return axios({
      method: 'get',
      params,
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },

  getBcCategories(params) {
    const URL = `Masters/${params.projid}/Bcs/Categories`;

    return axios({
      method: 'get',
      url: URL,
      params,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },

  getCompanies(params) {
    const { type, id } = params;
    const URL = `Masters/${id}/Companies/List`;

    return axios({
      method: 'get',
      url: URL,
      params: { type },
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  getConcretes(projid) {
    const URL = `Masters/${projid}/Concretes/Grades`;

    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  getHistory(params) {
    const URL = `Rfids/${params.id}/History`;

    return axios({
      method: 'get',
      url: URL,
      params,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  getRegions(params) {
    const URL = `Masters/${params.projid}/Locations/Regions`;

    return axios({
      method: 'get',
      url: URL,
      params,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },

  getFloors(params) {
    const URL = `Masters/${params.projid}/Locations/Floors`;

    return axios({
      method: 'get',
      url: URL,
      params,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  getContractList(params) {
    const URL = `Masters/Contracts/List`;

    return axios({
      method: 'get',
      url: URL,
      params,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  getLocationList(params) {
    const URL = `Masters/${params.projid}/Locations/List`;

    return axios({
      method: 'get',
      url: URL,
      params,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },

  getBcReport(params) {
    const { bctype = '', projid = '', lang = 'TC' } = params;

    const URL = `Reports/${projid}/BCs/${bctype}/${lang}`;
    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'arraybuffer'
    });
  },
  getBcAlertReport(params) {
    const { bctype = '', projid = '', lang = 'TC' } = params;

    const URL = `Reports/${projid}/DataAccuracyAlert/${lang}`;
    return axios({
      method: 'get',
      params: { bctype },
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'arraybuffer'
    });
  },
  getBcStats(params) {
    const { bctype = '', projid = '' } = params;

    const URL = `Stats/${projid}/BCs/${bctype}`;
    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  getBcAccumulates(params) {
    const { bctype = '', projid = '' } = params;

    const URL = `Stats/${projid}/BCs/${bctype}/Accumulate`;
    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  getWorkflowSteps(params) {
    const { bctype = '', projid = '' } = params;

    const URL = `Masters/${projid}/WorkFlows/Steps/FullList`;
    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  getWorkflowList(params) {
    const { projid = '' } = params;

    const URL = `Masters/${projid}/WorkFlows/List`;
    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  getSettingData(params) {
    const { projid = '', masterType = '' } = params;

    const URL = `Masters/${projid}/Setting/${masterType}/List`;
    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  addSettingData(params) {
    const { projid = '', masterType = '', data = {} } = params;

    const URL = `Masters/${projid}/Setting/${masterType}`;
    return axios({
      method: 'post',
      url: URL,
      data,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  updateSettingData(params) {
    const { projid = '', masterType = '', data = {} } = params;

    const URL = `Masters/${projid}/Setting/${masterType}`;
    return axios({
      method: 'put',
      url: URL,
      data,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  getCompanyTypes() {
    const URL = `Masters/Companies/Types`;
    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  getGpsHistory(params) {
    const { projid = '' } = params;

    const URL = `Admin/${projid}/GpsHist/List`;
    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  addUpdateGpsHistory(params) {
    const { projid = '', data } = params;

    const URL = `Admin/${projid}/GpsHist/CreateUpdate`;
    return axios({
      method: 'post',
      url: URL,
      data,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  getVehicles(params) {
    const { projid = '' } = params;

    const URL = `Admin/${projid}/Vehicle/List`;
    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  addUpdateVehicle(params) {
    const { projid = '', data } = params;

    const URL = `Admin/${projid}/Vehicle/CreateUpdate`;
    return axios({
      method: 'post',
      url: URL,
      data,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  getSettingExcel(params) {
    const { projid = '', masterType = '' } = params;

    const URL = `Masters/${projid}/Setting/${masterType}`;
    return axios({
      method: 'get',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'arraybuffer'
    });
  },
  confirmUploadSettingExcel(params) {
    const { projid = '', masterType = '', data = [] } = params;

    const URL = `Masters/${projid}/Setting/${masterType}/Confirmation`;
    return axios({
      method: 'post',
      url: URL,
      data,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  validateSettingExcel(params) {
    const { projid = '', masterType = '', file = '' } = params;

    const URL = `Masters/${projid}/Setting/${masterType}/Validation`;
    return axios({
      method: 'post',
      url: URL,
      data: { file },
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  getSettingLogs(params) {
    const { projid = '', masterType = '', data } = params;

    const URL = `Masters/${projid}/Setting/${masterType}/AuditLog`;
    return axios({
      method: 'post',
      url: URL,
      data,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },

  dispoeRfidDetails(detailId) {
    const URL = `Rfids/${detailId}/Dispose`;

    return axios({
      method: 'delete',
      url: URL,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },
  substituteVehicle(params) {
    const { rfidmoduleid = '', data } = params;

    const URL = `Rfids/${rfidmoduleid}/Vehicle/Substitution`;

    return axios({
      method: 'post',
      url: URL,
      data,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },

  batchSetAppDeviceVersionTargets(params) {
    return axios({
      method: 'put',
      url: 'Users/AppVersion/Targets',
      data: params,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  },

  setUpdateLocalData(params) {
    return axios({
      method: 'put',
      url: 'Users/AppVersion/UpdateLocalData',
      data: params,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
  }
};
